import './defaultViewNoContent.less'
import React from 'react'
import { Button, ButtonProps, Col, Row, Typography } from '@lightbeamai/design-system'

interface IProps {
  header?: string
  body?: string
  subBody?: string
  buttonLabel?: string
  buttonSize?: ButtonProps['size']
  handleAction?: () => void
  SvgIcon: React.FC<React.SVGProps<SVGSVGElement>>
  showSecondaryBtn?: boolean
  secondaryButtonLabel?: string
  secondarySubBody?: string
  handleSecondaryBtnAction?: () => void
}

const DefaultViewNoContent = (props: IProps) => {
  const {
    header,
    body,
    buttonLabel,
    buttonSize,
    handleAction,
    subBody,
    SvgIcon,
    showSecondaryBtn = false,
    secondarySubBody,
    secondaryButtonLabel,
    handleSecondaryBtnAction
  } = props
  return (
    <div className="no-consents-default-container">
      <div>
        <SvgIcon />
      </div>
      <div className="container-body">
        <Typography variant="base" type="medium" className="heading">
          {header}
        </Typography>
        <Typography variant="baseMinus4" className="body">
          {body}
        </Typography>
        <Row align={'middle'}>
          {handleAction && (
            <>
              <Col span={showSecondaryBtn ? 4 : 0}>
                {subBody && (
                  <Typography variant="baseMinus2" className="sub-body">
                    {subBody}
                  </Typography>
                )}
                <Button
                  variant="primary"
                  size={buttonSize}
                  className="config-button"
                  onClick={handleAction}
                >
                  {buttonLabel}
                </Button>
              </Col>
              {showSecondaryBtn && (
                <Col span={2} style={{ textAlign: 'center' }}>
                  <Typography as="span" variant={'baseMinus2'} type={'medium'}>
                    OR
                  </Typography>
                </Col>
              )}
            </>
          )}
          {showSecondaryBtn && (
            <Col span={6}>
              {secondarySubBody && (
                <Typography variant="baseMinus2" className="sub-body">
                  {secondarySubBody}
                </Typography>
              )}
              <Button
                variant="secondary"
                size={buttonSize}
                className="config-button"
                onClick={handleSecondaryBtnAction}
              >
                {secondaryButtonLabel}
              </Button>
            </Col>
          )}
        </Row>
      </div>
    </div>
  )
}

export default DefaultViewNoContent
